import React, {Component} from 'react'
import {Alert, Button, Input, Modal, Select} from 'antd'
import getHistory from '../../../../helpers/rounting/getHistory'
import {TYPE_PARTNER} from '../../../../helpers/typePartner'
import {createPartnerV2} from "../../../../services/api/3dApi"

const {Option} = Select

class AddPartnerModal extends Component {
    state = {
        loading: false,
        error: '',
        name: '',
        type: 'print_partner'
    }

    _closeModal = () => {
        const {onClose} = this.props

        this.setState({
            error: '',
            name: '',
            type: 'print_partner'
        }, () => {
            onClose()
        })
    }

    _handleChangeInput = (e) => {
        const {value} = e.target

        this.setState({
            name: value
        })
    }

    _handleChangeSelect = (value) => {

        this.setState({
            type: value
        })
    }

    _createPartner = async () => {
        this.setState({
            loading: true,
            error: ''
        })

        try {
            const {name, type} = this.state

            const {data} = await createPartnerV2({name, type_partner: type})

            const {success, error} = data

            if (!success) {
                this.setState({
                    loading: false,
                    error: error
                })
                return
            }

            this.setState({
                loading: false
            }, () => {
                if (data.data._id) {
                    const history = getHistory()
                    history.push(`/partners/${data.data._id}`)
                }
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    render() {
        const {loading, error, name, type} = this.state
        const {isOpen} = this.props

        return (
            <Modal
                title="Tạo đối tác"
                visible={isOpen}
                onOk={this._createPartner}
                onCancel={this._closeModal}
                footer={[
                    <Button key="back" onClick={this._closeModal}>
                        Hủy
                    </Button>,
                    <Button key="submit" type="primary" loading={loading} onClick={this._createPartner}>
                        Tạo
                    </Button>
                ]}
            >
                {error && <Alert className='mb-3' message={error} type='error'/>}

                <div className="mb-3">
                    <label>Tên đối tác</label>
                    <Input value={name || ''} onChange={this._handleChangeInput}/>
                </div>
                <div className="mb-3">
                    <label>Loại đối tác</label>
                    <Select defaultValue={type} onChange={this._handleChangeSelect}>
                        {
                            TYPE_PARTNER.map((item, index) => {
                                return <Option key={index} value={item.value}>{item.name}</Option>
                            })
                        }
                    </Select>
                </div>
            </Modal>
        )
    }
}

export default AddPartnerModal
